export const apiUrl = 'https://api.yundangdang.cn'
export const ossUrl = 'https://yundangdang.oss-accelerate.aliyuncs.com'
export const mqttUrl = 'post-cn-mp91f9f0i0u.mqtt.aliyuncs.com'

export const MQTT_GROUP_ID = 'GID_YUNDANGDANG'
export const MQTT_TOPIC = 'YUNDANGDANG'

export const ADMIN_ROLE_ID = 1

export const getDeviceId = () => {
  const deviceId = localStorage.getItem('device_id') || 'pc-' + new Date().getTime()
  localStorage.setItem('device_id', deviceId)
  return deviceId
}
export const getSessionTopics = () => {
  const mqttTopics = sessionStorage.getItem('mqtt_topics')
  if (mqttTopics) {
    return mqttTopics.split('|')
  } else {
    return []
  }
}

export const perPage = () => parseInt(localStorage.getItem('pagination.per_page')) || 20
export const pages = [
  { text: '10', value: 10 },
  { text: '15', value: 15 },
  { text: '20', value: 20 },
  { text: '50', value: 50 },
  { text: '100', value: 100 }
]
export const pagination = () => ({
  itemsPerPage: perPage(),
  page: 1,
  total: 1,
  sortBy: [],
  sortDesc: [],
  filters: {
    ranges: []
  }
})

export const addressTypes = [
  { text: '装车地址', abbr: '装', value: 'freight_load' },
  { text: '卸货地址', abbr: '卸', value: 'freight_unload' }
]

export const booleanSelections = [
  { text: '是', value: true },
  { text: '否', value: false }
]

export const dateGroupDimensions = [
  { text: '按月分组', value: 'monthly' },
  { text: '按周分组', value: 'weekly' },
  { text: '按天分组', value: 'daily' }
]
export const addressGroupDimensions = [
  { text: '按省分组', value: 'provincial' },
  { text: '按市分组', value: 'municipal' }
]

export const steps = {
  driver_binded: 4,
  freight_loaded: 5,
  freight_loaded_defraying: 6,
  freight_loaded_confirmed: 7,
  freight_unloaded: 8,
  freight_unloaded_defraying: 9,
  freight_unloaded_confirmed: 10,
  receipt_expressed: 11,
  receipt_collected_defraying: 12,
  receipt_collected_confirmed: 13,
  order_commented: 14
}
